import parse from 'html-react-parser'
import DOMPurify from 'isomorphic-dompurify'

DOMPurify.setConfig({})

export const html2jsx = (html) => parse(DOMPurify.sanitize(html))
